<template lang="pug">
.appTutorialBoxComponent
  .box(
    v-if="item.pointer"
    :class="boxClasses"
    :style="boxPosition"
  )
    .arrow(
      v-if="item.hover"
      :class="arrowClasses"
    )
      ui-svg-icon(name="arrow-left")
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'AppTutorialBox',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  setup (props) {
    const arrowClasses = computed(
      () => props.item.pointer.direction && `_${props.item.pointer.direction}`
    )
    const boxClasses = computed(() => ({ _hover: props.item.hover }))
    const boxPosition = computed(() => {
      return {
        left: `${props.item.pointer.x}%`,
        top: `${props.item.pointer.y}%`
      }
    })

    return {
      arrowClasses,
      boxClasses,
      boxPosition
    }
  }
}
</script>

<style lang="sass" scoped>
.appTutorialBoxComponent
  .box
    position: absolute
    width: 5.43%
    height: 10%
    border: 3px solid #B5F8D0
    border-radius: 30%
    &._hover
      border-color: $cGreen
  .arrow
    color: $cGreen
    position: absolute
    top: 50%
    transform: translateY(-50%)
    left: 130%
    width: 9*$u
    height: 6*$u
    z-index: 1
    &._right
      left: initial
      right: 140%
      transform: translateY(-50%) rotate(180deg)
    &._top
      top: 140%
      transform: translateX(-50%) rotate(90deg)
      left: 50%
    &._down
      top: initial
      bottom: 140%
      transform: translateX(-50%) rotate(-90deg)
      left: 50%

  &._id-1
    &._1
      .box
        width: 11%
        border-radius: 3*$u

    &._2
      .box
        width: 20%
        height: 18%
        border-radius: 3*$u
      .arrow
        left: 105%

    &._3
      .box
        width: 19%
        height: 47%
        border-radius: 3*$u
      .arrow
        left: 108%

  &._id-10
    &._2
      .box
        width: 11%
        height: 7.5%
        border-radius: 3*$u
      .arrow
        left: 115%

</style>
